export enum offerTypeMap {
  onSite,
  received,
  inTransit,
  directed
}
